import { baseApi } from "api/BaseApi";

import { TraineeCheck, ProjectPersonnel } from "./personnel.types";

const PERSONNEL_BASE_URL = "project/personnel";

const personnelApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // NOTE: Idk that this is even a real thing.
    // I cannot find a single personnel object with role==="Trainee"
    isTrainee: build.query<boolean, string | number>({
      query: (productId) => ({
        url: `${PERSONNEL_BASE_URL}/is_trainee`,
        params: { product: productId },
      }),
      transformResponse: (response: TraineeCheck) => response.is_trainee,
    }),

    getAllProductEvaluators: build.query<ProjectPersonnel[], string | number>({
      query: (productId) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_evaluators`,
        params: { product: productId },
      }),
    }),

    getApprovedProductValidators: build.query<
      ProjectPersonnel[],
      string | number
    >({
      query: (productId) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_validators`,
        params: { product: productId, approved: true },
      }),
    }),

    getApprovedAmValidators: build.query<ProjectPersonnel[], string | number>({
      query: (maintenanceId) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_validators`,
        params: { maintenance: maintenanceId, approved: true },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useIsTraineeQuery,
  useGetAllProductEvaluatorsQuery,
  useGetApprovedProductValidatorsQuery,
  useGetApprovedAmValidatorsQuery,
} = personnelApi;
